import { NbDialogService, NbToastrService } from '@nebular/theme';
import { PagingService } from './../../../../shared/Services/PagingService';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { DataSourceValuesService } from '../../services/data.cource.values';
import { GetFieldPropsComponent } from '../../../forms.properties/components/get/get.component';
import { CreateDataSourceValuesComponent } from '../create/create.component';
import { UpdateDataSourceValuesComponent } from '../update/update.component';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'formsfeild-get',
  templateUrl: './get.component.html',
  styleUrls: ['./get.component.scss'],
})
export class GetSourceValueComponent extends BaseComponent implements OnInit {
  formmasterId: number;
  constructor(
    public route: Router,
    public service: DataSourceValuesService,
    public paging: PagingService,
    private activated: ActivatedRoute,
    private diag: NbDialogService,
    private toaster: NbToastrService
  ) {
    super(route, service, paging);
  }

  ngOnInit() {
    this.formmasterId = this.activated.snapshot.params.id;
    this.pagingModel.query.searchTerm = 'DataSourceMasterId:' + this.formmasterId;
    this.loadEntities();
  }

  formsfields(id) {
    this.route.navigate(['admin/dynamicForms/formsfields/' + id]);
  }

  props(typeId, fieldId, formsfieldslist) {
    this.diag.open(GetFieldPropsComponent, { context: { typeId: typeId, fieldId: fieldId, item: formsfieldslist } });
  }

  addField() {
    this.diag
      .open(CreateDataSourceValuesComponent, { context: { formMasterId: this.formmasterId } })
      .onClose.subscribe((res) => {
        if (res === 'true') this.ngOnInit();
      });
  }

  update(item) {
    this.diag.open(UpdateDataSourceValuesComponent,{context: {sourcesValues: item}}).onClose.subscribe(res=>{
      if(res ==='true') this.ngOnInit();
    });
  }

  delete(id) {
    this.service.delete(id).subscribe((res) => {
      this.toaster.success('Deleted data successfully', 'success', { duration: 4000 });
      this.ngOnInit();

    });
  }
}
